// continueInChatBridge — lets the action-proposal registry (`builtinActions.ts`,
// a plain module that cannot call hooks) open the Analyze drawer's
// "Continue in chat" choice. Same shape as `sourceWizardBridge.ts`: the
// mounted `ChartAnalysisDrawer` publishes its opener here, the
// `continue_in_chat` executor calls `openContinueInChat(...)`.
//
// Plan 2026-10-09-continue-tile-analysis-in-chat §E: the agent's proposal opens
// the SAME choice as the drawer's button (this conversation, or a private
// copy). Nothing navigates or runs until the user picks.

/** What the user picked; `null` when they closed the choice. */
export type ContinueInChatChoice = "continued" | "copied" | null;

export type OpenContinueInChat = (conversationId: string) => Promise<ContinueInChatChoice>;

let opener: OpenContinueInChat | null = null;

/** Called by `ChartAnalysisDrawer` while it is open (and with `null` after). */
export function setContinueInChatOpener(fn: OpenContinueInChat | null): void {
  opener = fn;
}

/**
 * Open the drawer's choice for `conversationId`. Rejects when no drawer is
 * mounted, so a confirm click on a card outside the drawer fails loudly
 * instead of silently doing nothing.
 */
export function openContinueInChat(conversationId: string): Promise<ContinueInChatChoice> {
  if (!opener) {
    return Promise.reject(new Error("Continue in chat is only available from the Analyze panel."));
  }
  return opener(conversationId);
}
